module.exports = __webpack_public_path__ + "static/media/dice-d12.50dbe425.svg";